(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 52);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mr":"mr","ml":"ml"};

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DUIKON", function() { return DUIKON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return Icon; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(114);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_2__);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



var DUIKON;
(function (DUIKON) {
    DUIKON["close"] = "close";
    DUIKON["arrow_left"] = "arrow_left";
    DUIKON["arrow_right"] = "arrow_right";
    DUIKON["plus_rounded"] = "plus_rounded";
    DUIKON["pin_rounded_circle"] = "pin_rounded_circle";
    DUIKON["message_2"] = "message_2";
    DUIKON["calendar_2"] = "calendar_2";
    DUIKON["building_plan"] = "building_plan";
    DUIKON["tap_click_force_touch"] = "tap_click_force_touch";
    DUIKON["ruler"] = "ruler";
    DUIKON["video_camera"] = "video_camera";
    DUIKON["phone_two"] = "phone_two";
    DUIKON["smile"] = "smile";
    DUIKON["attachment"] = "attachment";
    DUIKON["picture"] = "picture";
    DUIKON["view_simple"] = "view_simple";
    DUIKON["lightbulb"] = "lightbulb";
    DUIKON["wallet"] = "wallet";
    DUIKON["view_grid"] = "view_grid";
    DUIKON["view_list"] = "view_list";
    DUIKON["profile_card"] = "profile_card";
    DUIKON["front_store"] = "front_store";
    DUIKON["rocket"] = "rocket";
    DUIKON["buildings"] = "buildings";
    DUIKON["building"] = "building";
    DUIKON["shopping_bag"] = "shopping_bag";
    DUIKON["check"] = "check";
    DUIKON["more"] = "more";
    DUIKON["trending_down"] = "trending_down";
    DUIKON["trending_up"] = "trending_up";
    DUIKON["star"] = "star";
    DUIKON["add"] = "add";
    DUIKON["help"] = "help";
    DUIKON["message"] = "message";
    DUIKON["send_round"] = "send_round";
    DUIKON["inbox_paper_round"] = "inbox_paper_round";
    DUIKON["search_left"] = "search_left";
    DUIKON["settings"] = "settings";
    DUIKON["love"] = "love";
    DUIKON["edit"] = "edit";
    DUIKON["multitasking"] = "multitasking";
    DUIKON["gallery_grid_view"] = "gallery_grid_view";
    DUIKON["home"] = "home";
    DUIKON["profile_round"] = "profile_round";
    DUIKON["profile_plus_round"] = "profile_plus_round";
    DUIKON["clock"] = "clock";
    DUIKON["container"] = "container";
    DUIKON["globe_network"] = "globe_network";
    DUIKON["calendar"] = "calendar";
    DUIKON["stats"] = "stats";
    DUIKON["money_round"] = "money_round";
    DUIKON["cloud_up"] = "cloud_up";
    DUIKON["image_picture"] = "image_picture";
    DUIKON["camera"] = "camera";
    DUIKON["desktop"] = "desktop";
    DUIKON["phone"] = "phone";
    DUIKON["dropdown_arrow"] = "dropdown_arrow";
})(DUIKON || (DUIKON = {}));
var Icon = function (props) {
    var _a;
    var mr = props.mr, ml = props.ml, className = props.className, rest = __rest(props, ["mr", "ml", "className"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("i", __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("uikon", className, (_a = {},
            _a[_styles_scss__WEBPACK_IMPORTED_MODULE_2___default.a.mr] = mr,
            _a[_styles_scss__WEBPACK_IMPORTED_MODULE_2___default.a.ml] = ml,
            _a)) }, rest)));
};
Icon.displayName = "Icon";
/* harmony default export */ __webpack_exports__["default"] = (Icon);


/***/ })

/******/ });
});